import classNames from 'classnames';
import type { FC } from 'react';
import React, { memo } from 'react';

import { Breadcrumb } from '@sravni/react-design-system/lib/Breadcrumb';
import { Html, Reviews } from '@sravni/react-seo';
import { useStyles } from '@sravni/react-utils';
import SeoBlockTypes from '@sravni/types/lib/enums/SeoBlockTypes';
import type { IHtmlMeta } from '@sravni/types/lib/seo';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import { getItemPageLink, makeReviewsPageLink } from '@sravni/ugc/lib/organizations/linkMakers';

import { useIsWlPage } from '../../hooks/useIsWlPage';
import { useMetadataByPath } from '../../hooks/useMetadataByPath';
import { useFilters } from '../../store/hooks/filters';
import { useReviews } from '../../store/hooks/reviews';

import styles from './seo-blocks.module.scss';

export const SeoBlocks: FC = memo(() => {
  const { organizationType, service } = useFilters();
  const metadata = useMetadataByPath();

  const { breadcrumbs = [], contentBlocks = [] } = metadata || {};
  const reviews = useReviews();
  const isWl = useIsWlPage();
  const cx = useStyles(styles);
  const { listTypeUrl } = getOrganizationHelpers(organizationType);

  const reviewsPageType = service?.key ? service.alias : listTypeUrl;

  const htmlText = (contentBlocks.find((block) => block.type === SeoBlockTypes.Html) as IHtmlMeta)?.text;

  return (
    <>
      {reviews?.length > 0 ? (
        <Reviews
          heading="Отзывы"
          reviews={reviews}
          productType={getItemPageLink(organizationType)}
          allReviewsLink={makeReviewsPageLink(reviewsPageType)}
          gradient
          className={cx('h-mt-32', 'carousel', { 'h-mb-20': isWl })}
        />
      ) : null}
      {htmlText && <Html text={htmlText} className="h-mt-40" />}
      {!!breadcrumbs?.length && (
        <div className={classNames(styles.breadcrumbs, 'h-mt-36')}>
          <Breadcrumb>
            {breadcrumbs.map(({ url, title }) => (
              <Breadcrumb.Item href={url} key={url}>
                {title}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      )}
    </>
  );
});
